import { useRef } from 'react';
import { Link } from 'react-router-dom';

export default function MagneticButton({ to, href, onClick, children, className = '', testId, cursor, type = 'button', disabled = false }) {
  const ref = useRef(null);

  const onMove = (e) => {
    if (!window.matchMedia('(pointer: fine)').matches || !ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const dx = e.clientX - (rect.left + rect.width / 2);
    const dy = e.clientY - (rect.top + rect.height / 2);
    ref.current.style.transform = `translate(${dx * 0.18}px, ${dy * 0.18}px)`;
  };
  const onLeave = () => {
    if (ref.current) ref.current.style.transform = 'translate(0,0)';
  };

  const cls = `inline-flex items-center justify-center gap-2 will-change-transform transition-transform duration-300 ease-out ${className}`;
  const props = {
    ref, onMouseMove: onMove, onMouseLeave: onLeave,
    'data-testid': testId, 'data-cursor': cursor, className: cls,
  };

  if (to) return <Link to={to} {...props}>{children}</Link>;
  if (href) return <a href={href} {...props}>{children}</a>;
  return <button type={type} onClick={onClick} disabled={disabled} {...props}>{children}</button>;
}
